export default __webpack_public_path__ + "static/media/benifit-common-img.87df7f06.png";